import { IPoint2d } from '@/editor/math/IPoint2d';
import { EOperateMode } from '@/editor/types';
import { TGlobalStores } from '@/editor/stores';
import DrawWall from '../drawWall';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { pixelRatio2d, wallAdsorbDistance } from '@/editor/math/const';
import { IRulerInfo } from '@/editor/entities/2d/rulerModel';

export class DrawRectWall extends DrawWall {
  constructor(_gs: TGlobalStores) {
    super(_gs);
  }

  protected override async addWallPoint(point: IPoint2d, force: boolean = false) {
    if (!this._currentPoint) {
      // 点击第一次
      this._currentPoint = point;
    }

    if (!this._movePoint) return;

    const endPoint = force ? point : this._movePoint;

    // 如果吸附点与当前点距离小于吸附距离，则不添加墙体
    const distance = Point2dUtils.distanceTo(this._currentPoint, endPoint);
    if (distance < wallAdsorbDistance / pixelRatio2d) return;

    const start = Point2dUtils.clone(this._currentPoint);
    const end = Point2dUtils.clone(endPoint);

    const isAddSuccess = await this._gs.wallOperation.addWall({
      start,
      end,
      operateMode: EOperateMode.DrawRectWall
    });
    if (!isAddSuccess) return;

    this._wallAbsorbManager.updateWallData();
    this._currentPoint = null;
    this.clear();
  }

  protected override getVirtualWalls(start: IPoint2d, end: IPoint2d) {
    const leftBottomPoint = { x: Math.min(start.x, end.x), y: Math.min(start.y, end.y) };
    const leftTopPoint = { x: Math.min(start.x, end.x), y: Math.max(start.y, end.y) };
    const rightTopPoint = { x: Math.max(start.x, end.x), y: Math.max(start.y, end.y) };
    const rightBottomPoint = { x: Math.max(start.x, end.x), y: Math.min(start.y, end.y) };
    return [
      { start: leftTopPoint, end: rightTopPoint, thickness: this._gs.paramStore.wallThickness },
      { start: leftBottomPoint, end: leftTopPoint, thickness: this._gs.paramStore.wallThickness },
      { start: rightTopPoint, end: rightBottomPoint, thickness: this._gs.paramStore.wallThickness, noRuler: true },
      { start: rightBottomPoint, end: leftBottomPoint, thickness: this._gs.paramStore.wallThickness, noRuler: true }
    ];
  }

  protected override _handleRulerChange(index: string, value: number, rulerInfo: IRulerInfo) {
    if (!this._currentPoint || !this._movePoint) return;
    const startPoint = this._currentPoint;
    const endPoint = this._movePoint;

    if (index === '0') {
      // 水平标尺
      const rulerMidPoint = Point2dUtils.getCenter(rulerInfo.start, rulerInfo.end);
      const sign = Math.sign(rulerMidPoint.x - startPoint.x);
      const newEndPoint = { x: startPoint.x + value * sign, y: endPoint.y };

      this._movePoint = newEndPoint;
    } else if (index === '1') {
      // 垂直标尺
      const rulerMidPoint = Point2dUtils.getCenter(rulerInfo.start, rulerInfo.end);
      const sign = Math.sign(rulerMidPoint.y - startPoint.y);
      const newEndPoint = { x: endPoint.x, y: startPoint.y + value * sign };
      this._movePoint = newEndPoint;
    }

    this._updateVirtualWall(this._movePoint);
  }

  protected override _handleRulerCommit(index: string, value: number, rulerInfo: IRulerInfo) {
    if (!this._currentPoint || !this._movePoint) return;
    const startPoint = this._currentPoint;
    const endPoint = this._movePoint;

    if (index === '0') {
      // 水平标尺
      const rulerMidPoint = Point2dUtils.getCenter(rulerInfo.start, rulerInfo.end);
      const sign = Math.sign(rulerMidPoint.x - startPoint.x);
      const newEndPoint = { x: startPoint.x + value * sign, y: endPoint.y };

      void this.addWallPoint(newEndPoint, true);
    } else if (index === '1') {
      // 垂直标尺
      const rulerMidPoint = Point2dUtils.getCenter(rulerInfo.start, rulerInfo.end);
      const sign = Math.sign(rulerMidPoint.y - startPoint.y);
      const newEndPoint = { x: endPoint.x, y: startPoint.y + value * sign };
      void this.addWallPoint(newEndPoint, true);
    }
  }
}
